// eslint-disable-next-line arrow-body-style
const formatNumber = (quantity: string | number, digits: number = 0): string => {
    return Number(quantity).toLocaleString('nl', { maximumFractionDigits: digits });
};

export {
    // eslint-disable-next-line import/prefer-default-export
    formatNumber,
};
